export enum ZipCodeFormViewType {
    ZipCodeListByAreaName = "ZipCodeListByAreaName",
    ZipCodeListByStartWith = "ZipCodeListByStartWith",
    ZipCodeListByStartWithAndEndWith = "ZipCodeListByStartWithAndEndWith",
    ZipCodeListByRadius = "ZipCodeListByRadius",
    ZipCodeListCustom = "ZipCodeListCustom"
}
